import { __awaiter, __generator, __values } from "tslib";
import { deleteItem, getDB, read, writeAll } from '@office-start/idb-cache';
import { deleteDB } from 'idb';
var activeCollections = new Map();
var databaseName = 'office-start-simple-persistence';
var storeName = 'items';
function getSimplePersistence(userId, collectionName, collectionVersion) {
    return __awaiter(this, void 0, void 0, function () {
        var joinedName, activeCollectionPromise, collectionPromise_1, collection, ex_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    joinedName = userId + "." + databaseName + "." + collectionName;
                    activeCollectionPromise = activeCollections.get(joinedName);
                    if (activeCollectionPromise) {
                        return [2 /*return*/, activeCollectionPromise];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 7]);
                    collectionPromise_1 = getDB(joinedName, {
                        upgrade: function (upgradeDb) {
                            try {
                                upgradeDb.deleteObjectStore(storeName);
                            }
                            catch (_a) {
                                /*
                                Do nothing.
                                Deleting an objectStore that doesn't exist will throw an exception.
                                This will happen on the fist-time creation of this collection.
                                */
                            }
                            upgradeDb.createObjectStore(storeName);
                        },
                        blocking: function () {
                            collectionPromise_1.then(function (db) {
                                db.close();
                                activeCollections.delete(joinedName);
                            });
                        },
                        terminated: function () {
                            activeCollections.delete(joinedName);
                        },
                    }, collectionVersion);
                    return [4 /*yield*/, collectionPromise_1];
                case 2:
                    collection = _a.sent();
                    activeCollections.set(joinedName, collectionPromise_1);
                    return [2 /*return*/, collection];
                case 3:
                    ex_1 = _a.sent();
                    if (!(ex_1 instanceof DOMException)) return [3 /*break*/, 5];
                    // Delete the old collection.
                    return [4 /*yield*/, deleteDB(joinedName)];
                case 4:
                    // Delete the old collection.
                    _a.sent();
                    // retry creating the collection.
                    return [2 /*return*/, getSimplePersistence(userId, collectionName, collectionVersion)];
                case 5: throw new Error("Failed to create database with exception: " + ex_1.toString());
                case 6: return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function writeToSimplePersistence(userId, collectionName, collectionVersion, key, data, plugins, writeBehavior) {
    if (plugins === void 0) { plugins = []; }
    if (writeBehavior === void 0) { writeBehavior = 'replace'; }
    return __awaiter(this, void 0, void 0, function () {
        var db, plugins_1, plugins_1_1, plugin, e_1_1;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getSimplePersistence(userId, collectionName, collectionVersion)];
                case 1:
                    db = _b.sent();
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 7, 8, 9]);
                    plugins_1 = __values(plugins), plugins_1_1 = plugins_1.next();
                    _b.label = 3;
                case 3:
                    if (!!plugins_1_1.done) return [3 /*break*/, 6];
                    plugin = plugins_1_1.value;
                    if (!plugin.onBeforeWriteValue) return [3 /*break*/, 5];
                    return [4 /*yield*/, plugin.onBeforeWriteValue(data, key, {
                            userId: userId,
                            collectionName: collectionName,
                            collectionVersion: collectionVersion,
                        })];
                case 4:
                    data = _b.sent();
                    _b.label = 5;
                case 5:
                    plugins_1_1 = plugins_1.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (plugins_1_1 && !plugins_1_1.done && (_a = plugins_1.return)) _a.call(plugins_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9:
                    // Don't persist `null` or `undefined` data to storage.
                    if (!data) {
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, writeAll(db, [data], storeName, writeBehavior, [key])];
            }
        });
    });
}
export function readFromSimplePersistence(userId, collectionName, collectionVersion, key, plugins) {
    if (plugins === void 0) { plugins = []; }
    return __awaiter(this, void 0, void 0, function () {
        var db, item, plugins_2, plugins_2_1, plugin, e_2_1;
        var e_2, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getSimplePersistence(userId, collectionName, collectionVersion)];
                case 1:
                    db = _b.sent();
                    return [4 /*yield*/, read(db, storeName, key)];
                case 2:
                    item = _b.sent();
                    // If item is not in storage, return `null` indicating the read did not return any data.
                    if (!item) {
                        return [2 /*return*/, null];
                    }
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 8, 9, 10]);
                    plugins_2 = __values(plugins), plugins_2_1 = plugins_2.next();
                    _b.label = 4;
                case 4:
                    if (!!plugins_2_1.done) return [3 /*break*/, 7];
                    plugin = plugins_2_1.value;
                    if (!plugin.onAfterReadValue) return [3 /*break*/, 6];
                    return [4 /*yield*/, plugin.onAfterReadValue(item, key, {
                            userId: userId,
                            collectionName: collectionName,
                            collectionVersion: collectionVersion,
                        })];
                case 5:
                    item = _b.sent();
                    _b.label = 6;
                case 6:
                    plugins_2_1 = plugins_2.next();
                    return [3 /*break*/, 4];
                case 7: return [3 /*break*/, 10];
                case 8:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 10];
                case 9:
                    try {
                        if (plugins_2_1 && !plugins_2_1.done && (_a = plugins_2.return)) _a.call(plugins_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/, item];
            }
        });
    });
}
export function deleteFromSimplePersistence(userId, collectionName, collectionVersion, key) {
    return __awaiter(this, void 0, void 0, function () {
        var db;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getSimplePersistence(userId, collectionName, collectionVersion)];
                case 1:
                    db = _a.sent();
                    return [4 /*yield*/, deleteItem(db, storeName, key)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=SimplePersistence.js.map